// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-values-margin {
	margin-left: 1rem;
	margin-right: 1rem;
	font-weight: 900;
}

.all-values-border {
	border-bottom: 1px solid black;
}

.all-values-border-spacing {
	border-top: solid transparent 40px;
}

.all-values-header {
	font-size: 2.425rem;
	margin-top: 3rem;
}

.all-values-body {
	font-size: 1.11rem;
}

.all-values-footer {
	bottom: 0;
	position: fixed;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/kbb-all-values.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,eAAe;AAChB","sourcesContent":[".all-values-margin {\n\tmargin-left: 1rem;\n\tmargin-right: 1rem;\n\tfont-weight: 900;\n}\n\n.all-values-border {\n\tborder-bottom: 1px solid black;\n}\n\n.all-values-border-spacing {\n\tborder-top: solid transparent 40px;\n}\n\n.all-values-header {\n\tfont-size: 2.425rem;\n\tmargin-top: 3rem;\n}\n\n.all-values-body {\n\tfont-size: 1.11rem;\n}\n\n.all-values-footer {\n\tbottom: 0;\n\tposition: fixed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
